import { render } from "./FlashcardIcon.vue?vue&type=template&id=412c90da&ts=true"
import script from "./FlashcardIcon.vue?vue&type=script&lang=ts"
export * from "./FlashcardIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__